import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { configApi } from '@/api'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Landing',
    component: () => import('@/views/LandingPage.vue'),
    meta: {
      title: 'Spotty - The TON Meme Token 🚀',
    },
  },
  {
    path: '/spin',
    name: 'Spin',
    component: () => import('@/views/SpinPage.vue'),
    meta: {
      title: 'Spotty Daily Spin',
    },
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: () => import('@/views/MaintenancePage.vue'),
    meta: {
      title: 'Maintenance - Spotty',
    },
  },
  {
    path: '/auth/phantom-callback',
    name: 'PhantomCallback',
    component: () => import('@/views/PhantomCallbackPage.vue'),
    meta: {
      title: 'Connecting Phantom — Spotty',
    },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    }
    return { top: 0 }
  },
})

// Global navigation guard to enforce maintenance mode
router.beforeEach(async (to) => {
  // Always allow navigating to the maintenance page itself
  if (to.path === '/maintenance') {
    return true
  }
  // Phantom deeplink callback must complete even in maintenance mode —
  // otherwise a user who signed a tx in Phantom cannot return to the dapp.
  if (to.path === '/auth/phantom-callback') {
    return true
  }

  try {
    const maintenanceFlag = await configApi.getFlag('maintenance')
    const isMaintenance =
      maintenanceFlag.success && maintenanceFlag.data ? Boolean(maintenanceFlag.data.value) : false

    if (isMaintenance) {
      return { path: '/maintenance' }
    }
  } catch (error) {
    // In case of error fetching flag, fall back to allowing navigation;
    // initialization in main.ts already handles redirect to maintenance.
    console.error('Failed to check maintenance flag in router guard:', error)
  }

  return true
})

// Update document title based on route meta
router.afterEach((to) => {
  const title = to.meta.title as string
  if (title) {
    document.title = title
  }
})

export default router
